export default __webpack_public_path__ + "static/demander_une_demo-cf04547dd685a36ba83343ae33252b43.png";